import { Button } from '@vtbhome/juicyfront';
import { AllClose } from '@vtbhome/juicyfront/indexIcon';
import React, { useEffect, useState } from 'react';
import { ModalConfirm } from './modal-confirm/modal-confirm';
import { Toast } from '@shared/ui/toast/toast';
import toast from 'react-hot-toast';
import { DeclineEmployeeRequestProps } from './types';
import { getQueryError } from '@shared/lib/utils/get-query-error/get-query-error';
import { useCancelRequestMutation } from '@features/request/decline-manager-request/api/request-api';
import { CACHE_KEY_REQUEST_CANCEL } from '../config/api-constants';

export const DeclineEmployeeRequest: React.FC<DeclineEmployeeRequestProps> = ({ request, disabled, onSuccess }) => {
    const [, cancelRequestResult] = useCancelRequestMutation({ fixedCacheKey: CACHE_KEY_REQUEST_CANCEL });
    const [isShowModal, setIsShowModal] = useState(false);

    const handleClose = () => {
        setIsShowModal(false);
    };

    useEffect(() => {
        if (isShowModal && cancelRequestResult.isSuccess) {
            onSuccess();
            toast.custom((t) => {
                return (
                    <Toast
                        type='success'
                        title='Успешно!'
                        description={`Вы отменили регистрацию в продукте «${request.product.name}»`}
                        onClose={() => {
                            toast.remove(t.id);
                        }}
                    />
                );
            });
            cancelRequestResult.reset();
        } else if (isShowModal && cancelRequestResult.isError) {
            toast.custom((t) => {
                return (
                    <Toast
                        type='error'
                        title='Ошибка!'
                        description={`Не удалось отменить регистрацию в продукте.\n${getQueryError(cancelRequestResult)?.message}`}
                        onClose={() => {
                            toast.remove(t.id);
                        }}
                    />
                );
            });
            cancelRequestResult.reset();
        }
    }, [isShowModal, cancelRequestResult.isSuccess, cancelRequestResult.isError]);

    return (
        <>
            <Button
                disabled={disabled}
                size='s'
                preloader={cancelRequestResult.isLoading}
                buttonType='secondary'
                startAdornment={<AllClose size='xxs' />}
                onClick={() => setIsShowModal(true)}>
                Отменить
            </Button>
            <ModalConfirm isShow={isShowModal} request={request} onClose={handleClose} onConfirm={handleClose} />
        </>
    );
};
